var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{attrs:{"src":"https://www.instagram.com/_dontax_/embed","width":"100%","height":"99%"}})
}
var staticRenderFns = []

export { render, staticRenderFns }